window.PimV2VariantUi = {
  init(options) {
    this.initVariantUI(options);
  },

  initVariantUI(options) {
    const productName = options && options.productName ? options.productName : '';
    const pdpFilter = document.querySelectorAll('.pdp-variant-filter-selector');

    pdpFilter.forEach((element) => {
      element.addEventListener('click', () => {
        this.swapFilterSelection(element, productName);
      });
    });
  },

  swapFilterSelection(element, productName) {
    let filterName = element.getAttribute('data-filter');
    const labelFilterSelected = document.getElementById('variantCurrentFilterOption');

    if (productName.includes('25i')) {
      if (filterName == 'essential') {
        filterName += '-pure';
      } else if (filterName == 'advanced') {
        filterName += '-fresh';
      } else if (filterName == 'ultimate') {
        filterName += '-odor';
      }
    }

    labelFilterSelected.setAttribute('data-current-filter', filterName.replace(/-/g, ' '));
    labelFilterSelected.innerHTML = this.formatText(filterName);

    document.querySelectorAll('.pdp-variant-filter-selector').forEach((elementTemp) => {
      elementTemp.classList.remove('active-filter');
      elementTemp.parentElement.classList.remove('active-filter');
    });

    element.classList.add('active-filter');
    element.parentElement.classList.add('active-filter');

    setTimeout(function() {
      setStartingAtPriceOnPDP();
    }, 1000);
  },

  formatText(str) {
    const [first, second] = str.split('-');

    const capitalize = (text) =>
      text.charAt(0).toUpperCase() + text.slice(1);

    return `${capitalize(first)} (${capitalize(second)})`;
  }
};

window.PimV2VariantUI = window.PimV2VariantUi;
